import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import PollGroupListItem from './PollGroupListItem';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import classList from 'flarum/common/utils/classList';
/**
 * The `PollGroupList` component displays a list of poll groups.
 */
export default class PollGroupList extends Component {
  view() {
    const state = this.attrs.state;
    const params = state.getParams();
    const isLoading = state.isInitialLoading() || state.isLoadingNext();
    let loading;
    if (isLoading) {
      loading = m(LoadingIndicator, null);
    } else if (state.hasNext()) {
      loading = m(Button, {
        className: "Button",
        onclick: state.loadNext.bind(state)
      }, app.translator.trans('fof-polls.forum.poll_groups.list_page.load_more_button'));
    }
    if (state.isEmpty()) {
      const text = app.translator.trans('fof-polls.forum.poll_groups.list_page.empty_text');
      return m("div", {
        className: "PollGroupList"
      }, m(Placeholder, {
        text: text
      }));
    }
    return m("div", {
      className: classList('PollGroupList', {
        'PollGroupList--searchResults': state.isSearchResults()
      })
    }, m("ul", {
      "aria-busy": isLoading,
      className: "PollGroupList-pollgroups"
    }, state.getPages().map(pg => {
      return pg.items.map(pollGroup => m("li", {
        key: pollGroup.id(),
        "data-id": pollGroup.id()
      }, m(PollGroupListItem, {
        pollGroup: pollGroup,
        params: params,
        compactView: true
      })));
    })), m("div", {
      className: "PollGroupList-loadMore"
    }, loading));
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollGroup/PollGroupList', PollGroupList);